import $ from 'jquery';

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';

// import slickStyles from 'slick-carousel/slick/slick.css';
// import slick from 'slick-carousel';

const domElements = {};

function projectSlider() {
  if (storeDomElements() === false) {
    return;
  }

  if ($(window).width() < 768) return;

  if ($('.content-structure--text').length > 0) return;

  const swiper = new Swiper(domElements.slider[0], {
    slidesPerView: 'auto',
    spaceBetween: 25,
    keyboard: {
      enabled: true,
      onlyInViewport: false
    },
    // mousewheel: {
    //   //forceToAxis: true
    // },
    mousewheel: false,
    navigation: {
      nextEl: domElements.nextBtn[0],
      prevEl: domElements.prevBtn[0],
    },

    breakpoints: {
      768: {
        spaceBetween: 24,
      }
    }
  });

  setTimeout(() => {
    domElements.main.animate({opacity: 1}, 200);
  }, 100);

}

function storeDomElements() {
  domElements.main = $('.project-slider');

  if (domElements.main.length < 1) return false;

  domElements.slider = domElements.main.find('.project-slider__items');
  domElements.prevBtn = domElements.main.find('.project-slider__button-prev');
  domElements.nextBtn = domElements.main.find('.project-slider__button-next');

  return true;
}

export default projectSlider;
